<template>
  <div>
    <Card dis-hover>
      <p slot="title">支付总计：{{currentOrder.totalPrice|currency}}</p>
      <p class="p-5">印章小计：共 {{currentOrder.seals.length}} 个印章，合计 {{currentOrder.sealsPrice|currency}} </p>
      <p class="p-5" v-show="currentOrder.deliverType==='1'">邮费小计：共{{currentOrder.deliverPrice | currency}}</p>
    </Card>

    <div class="w-70" style="margin:0 15%">
      <div class="tb-row">
        <div class="m-t-20 ti-g-1" v-if="enableWxpay">
          <div class="f-700">微信：</div>
          <div class="m-l-80">
            <img src="img/weixin2.png">
            <div>
              <Button class="m-t-20"
                      @click="payModal.show = true,payModal.type = 1,polling(1)">
                去支付
              </Button>
            </div>
          </div>
        </div>
        <div class="m-t-20 ti-g-1" v-if="enableAlipay">
          <div class="f-700">支付宝：</div>
          <div class="m-l-80">
            <img src="img/zhifubao2.png">
            <div @click="payModal.show = true,payModal.type = 2" class="m-t-20">
              <a :href="orderPay.aliPayUrl" target="_blank">
                <Button @click="polling(0)">去支付</Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal v-model="payModal.show" :title="payModal.type == 2?'支付宝付款':'微信付款'" ok-text="关闭" cancel-text=""
           @on-cancel="cancelPay" @on-ok="cancelPay">
      <div class="tb-column-center">
        <img :src="orderPay.wxPaySrc" v-if="payModal.type == 1">
        <div v-if="payModal.type == 2">请在新打开的支付宝窗口进行付款</div>
        <div>支付金额：{{currentOrder.totalPrice|currency}}</div>
      </div>
    </Modal>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {api} from '@/libs'

  export default {
    name: 'OrderPay',
    data() {
      return {
        payModal: {
          show: false
        },
      }
    },
    computed: {
      ...mapState({
        currentOrder: state => state.order.currentOrder,
        enableWxpay: state => state.main.config.payment.wxpay,
        enableAlipay: state => state.main.config.payment.alipay,
      }),
      orderPay() {
        if (this.currentOrder.id) {
          return {
            wxPaySrc: api.url + api.gzwCusOrder.orderPayWxScan + this.currentOrder.id + '?token=' + localStorage.getItem('pcCustomToken'),
            aliPayUrl: api.url + api.gzwCusOrder.orderPayAlipayPc + this.currentOrder.id + '?token=' + localStorage.getItem('pcCustomToken'),
            plateform: 0
          }
        } else return {
          plateform: 0
        }
      },
    },
    methods: {
      // 设置周期调用
      polling(type) {
        const that = this
        this.checkState = setInterval(() => {
          that.$store.dispatch('order/getOrderById', {id: that.currentOrder.id}).then(payload => {
            if (payload.orderState === '1') {
              clearInterval(that.checkState)
              that.$router.push({path: '/custom/order/current'})
            }
          })
        }, 1000)
        this.payModal.payType = type
      },

      // 取消周期调用
      cancelPay() {
        clearInterval(this.checkState)
      },
    },
    created() {
    }
  }
</script>